<ul class="navbar-nav me-auto user-action">
  <li class="nav-item dropdown">
    <a
      class="nav-link dropdown-toggle"
      href="javascript:;"
      id="navbarDropdown"
      role="button"
      data-bs-toggle="dropdown"
      aria-haspopup="true"
      aria-expanded="false"
      >
      @if (showUserText) {
        <span class="me-2">{{ userName }}</span>
      }
      <nb-icon icon="person-outline"></nb-icon>
    </a>
    <div class="dropdown-menu" aria-labelledby="navbarDropdown">
      <!-- <a class="dropdown-item role-item" href="javascript:;"
      ><span class="role-label">{{
      'HEADER.USER_MENU.ROLE' | translate
      }}</span
      ><span class="role-value ms-2">asasasas</span></a
      > -->
      <a
        class="dropdown-item"
        href="javascript:;"
        (click)="navigateTo('/profilo/dati-utente')"
        >{{ 'HEADER.USER_MENU.USER_DATA' | translate }}</a
        >
        <div class="dropdown-divider"></div>
        <a
          class="dropdown-item logout-item"
          href="javascript:;"
          (click)="navigateTo('/auth/logout')"
          >{{ 'HEADER.USER_MENU.LOGOUT' | translate }}</a
          >
        </div>
      </li>
    </ul>
